import React from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CategoryIconPicker, { CategoryIconPickerProps } from "./CategoryIconPicker";

const CategoryIconPickerWithLabel: React.FC<CategoryIconPickerProps> = (props) => {
    const { t } = useTranslation();
    return (
        <>
            <Col sm={3}>
                <label className="fs-7 fw-bold text-start pt-sm-2 mb-sm-0">{t("Category Icon")}</label>
            </Col>
            <Col sm={9}>
                <CategoryIconPicker {...props} />
            </Col>
        </>
    );
};

export default CategoryIconPickerWithLabel;
